<template>
  <div class="handle-button" style="display: inline">
    <el-button :disabled="invoiceLoadding" @click="invoiceApplyBtn" class="d-flex-row funcbars-button"
               v-if="userAuth.can_add_invoice" size="mini" style="margin-right: 10px;">
      <i class="el-icon-plus"></i>申请开票
    </el-button>
    <el-dialog title="发票信息" :visible.sync="dialogInvoice" width="1000px" :close-on-click-modal="false"
               :modal-append-to-body="true" :append-to-body="true">
      <div class="d-flex-column d-flex-center" style="padding: 0px 24px;">
        <InvoiceApply ref="invoiceApply" @showErrorEvent="showInvoiceFail" @showedEvent="showInvoiceSuccess"
                      @submited="afterSubmitInvoice" @closeEvent="closeInvoiceDialog"></InvoiceApply>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import InvoiceApply from "@/views/bill/components/InvoiceApply";

export default {
  name: "ApplyInvoiceOpt",
  components: {
    InvoiceApply
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    isWcm: Boolean
  },
  data() {
    return {
      invoiceLoadding: false,
      dialogInvoice: false,
    }
  },
  methods: {
    // 申请开票
    invoiceApplyBtn() {
      let _selectItems = this.dataList
      if (!_selectItems || (Array.isArray(_selectItems) && _selectItems.length <= 0)) {
        this.showInvoiceFail("至少选择一条广告订单");
        return false;
      }
      if (this.isWcm) {
        // 是全案营销项目
        let is_err = false
        for (let i = 0; i < _selectItems.length; i++) {
          const row = _selectItems[i]
          if (Number(row.invoice_money_done) === 0 && Number(row.invoice_money_occupy) === 0) {
            this.showInvoiceFail(`请前往【广告订单】页面，为${row.order_no}下的子订单单独申请开票。`);
            is_err = true
            break;
          }
        }
        if (is_err) {
          return false;
        }
      }
      this.dialogInvoice = true;
      this.$nextTick(() => {
        this.$refs['invoiceApply'].showReceipt(_selectItems)
      })

    },
    //发票信息：展示失败
    showInvoiceFail(error_msg) {
      this.showToast({
        h: this,
        icon: "el-icon-error",
        text: error_msg,
        duration: 3000
      });
      this.closeInvoiceDialog()
    },
    //发票信息：展示成功
    showInvoiceSuccess() {
      this.$notify.success('发票信息展示成功')
    },
    //发票信息：提交成功
    afterSubmitInvoice() {
      this.closeInvoiceDialog()
      this.$emit('applied');
    },
    closeInvoiceDialog() {
      this.dialogInvoice = false;
    },
  }
}
</script>

<style scoped>
</style>
